import {put, select, takeEvery} from 'redux-saga/effects'
import {fareAlertSubmitted, SUBMIT_FARE_ALERT} from "../actions/FareAlertActions";
import axios from 'axios';
import qs from 'querystring';

function* submitFareAlert(action) {
    const state = yield select();
    const cheapest = state.FlightsReducer.cheapest[0];
    const general = cheapest ? cheapest.general : undefined;

    // The price checker stores and compares per-person prices, so the baseline has to be per
    // person too. Seeding it with the basket total makes the very first check look like a drop
    // and sends a bogus "price decreased" email.
    const price = general
        ? general.averageFlightPricePerPerson + general.serviceFeePerPerson
        : undefined;

    // The cheapest flight arrives over the socket, so it can still be missing when the form is
    // submitted. Sending it anyway stores an alert with no baseline price to compare against.
    if (typeof price !== 'number' || !isFinite(price) || price <= 0) {
        return;
    }

    const response = axios.post(
        action.alertUrl,
        qs.stringify(
            {
                email: action.email,
                currency: action.currency,
                price,
                uid: state.SocketReducer.cacheId
            }
        ),
        {
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            withCredentials: true
        }
    );

    yield put(fareAlertSubmitted(response));
}

function* flightAlertSaga() {
    yield takeEvery(SUBMIT_FARE_ALERT, submitFareAlert);

}

export default flightAlertSaga;



// WEBPACK FOOTER //
// ./src/saga/flightAlertSaga.js